import React from "react";

export default function IcoPayment() {
  return (
    <svg
      width="17"
      height="12"
      viewBox="0 0 17 12"
      fill="none"
      className="fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12.7405 0.0107422H3.61054C1.81171 0.0136959 0.352563 1.46989 0.349609 3.27167H15.9985C15.9985 1.47284 14.5394 0.0136959 12.7405 0.0107422Z" />
      <path d="M0.349609 8.4879C0.352563 10.2867 1.80876 11.7459 3.61054 11.7488H12.7405C14.5394 11.7459 15.9985 10.2897 16.0015 8.4879V4.57715H0.349609V8.4879ZM4.91314 8.16299C4.91314 8.70352 4.47598 9.14068 3.93545 9.14068C3.39492 9.14068 2.95776 8.70352 2.95776 8.16299C2.95776 7.62245 3.39492 7.1853 3.93545 7.1853C4.47598 7.1853 4.91314 7.62245 4.91314 8.16299Z" />
    </svg>
  );
}
